<template>
  <div class="page-wrapper">
    <div class="card">

      <h2 class="page-title">🚚 Master Delivery By</h2>

      <!-- FORM TAMBAH / EDIT -->
      <div class="form-row">
        <input
          v-model="form.name"
          type="text"
          placeholder="Nama delivery method"
          class="input"
        />

        <button @click="saveDelivery" class="btn-primary">
          {{ form.id ? "Update" : "Simpan" }}
        </button>
      </div>

      <!-- SEARCH -->
      <div class="search-row">
        <input
          v-model="search"
          type="text"
          placeholder="🔍 Cari delivery..."
          class="input search"
        />
        <button @click="search=''" class="btn-secondary">
          Reset
        </button>
      </div>

      <!-- TABLE -->
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Nama</th>
              <th>Status</th>
              <th class="right">Aksi</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="d in filteredDelivery" :key="d.id">
              <td class="bold">{{ d.name }}</td>

              <td>
                <span
                  :class="Number(d.is_active) === 1
                    ? 'status active'
                    : 'status inactive'"
                >
                  {{ Number(d.is_active) === 1 ? "Aktif" : "Nonaktif" }}
                </span>
              </td>

              <td class="right">
                <button @click="editDelivery(d)" class="btn-link edit">
                  Edit
                </button>

                <button
                  @click="toggleDelivery(d.id)"
                  class="btn-link danger"
                >
                  {{ Number(d.is_active) === 1 ? "Nonaktifkan" : "Aktifkan" }}
                </button>

                <button
                  @click="confirmDelete(d)"
                  class="btn-link danger"
                >
                  Hapus
                </button>
              </td>
            </tr>

            <tr v-if="filteredDelivery.length === 0">
              <td colspan="3" class="empty">
                Delivery method tidak ditemukan
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "DeliveryMethodsList",

  data() {
    return {
      delivery: [],
      search: "",
      form: {
        id: null,
        name: ""
      }
    };
  },

  mounted() {
    this.fetchDelivery();
  },

  computed: {
    filteredDelivery() {
      const q = this.search.toLowerCase();
      return this.delivery.filter(d =>
        d.name.toLowerCase().includes(q)
      );
    }
  },

  methods: {
    async fetchDelivery() {
      const res = await fetch("/api/delivery_methods/get_delivery_methods.php");
      const json = await res.json();
      this.delivery = json.data || [];
    },

    editDelivery(d) {
      this.form = {
        id: d.id,
        name: d.name
      };
    },

    async saveDelivery() {
      const url = this.form.id
        ? "/api/delivery_methods/update.php"
        : "/api/delivery_methods/create.php";

      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(this.form)
      });

      const json = await res.json();

      if (!json.success) {
        alert("Gagal: " + json.message);
        return;
      }

      this.resetForm();
      this.fetchDelivery();
    },

    async toggleDelivery(id) {
      await fetch("/api/delivery_methods/toggle.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id })
      });

      this.fetchDelivery();
    },

    async confirmDelete(item) {
      const ok = confirm(
        `⚠️ Yakin hapus delivery:\n\n"${item.name}"?`
      );

      if (!ok) return;

      await fetch("/api/delivery_methods/delete.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: item.id })
      });

      this.fetchDelivery();
    },

    resetForm() {
      this.form = { id: null, name: "" };
    }
  }
};
</script>

<style scoped>
.page-wrapper {
  padding: 24px;
  max-width: 1000px;
  margin: auto;
}

.card {
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 14px rgba(0,0,0,0.05);
}

.page-title {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 20px;
}

/* FORM */
.form-row {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
}

.search-row {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}

.input {
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 14px;
  width: 100%;
}

.input.search {
  max-width: 260px;
}

/* BUTTON */
.btn-primary {
  background: #3b82f6;
  color: #fff;
  border-radius: 10px;
  padding: 10px 18px;
  font-weight: 600;
  white-space: nowrap;
}

.btn-primary:hover {
  background: #2563eb;
}

.btn-secondary {
  background: #f3f4f6;
  border-radius: 10px;
  padding: 10px 16px;
}

.btn-link {
  font-weight: 500;
  margin-left: 8px;
  border: none;
  background: none;
  cursor: pointer;
}

.btn-link.edit {
  color: #2563eb;
}

.btn-link.danger {
  color: #dc2626;
}

/* TABLE */
.table-wrapper {
  border-top: 1px solid #eee;
  margin-top: 12px;
}

table {
  width: 100%;
  border-collapse: collapse;
}

thead th {
  text-align: left;
  padding: 14px 10px;
  font-size: 14px;
  color: #555;
}

tbody td {
  padding: 14px 10px;
  border-top: 1px solid #f0f0f0;
  font-size: 14px;
}

.right {
  text-align: right;
}

.bold {
  font-weight: 500;
}

.status {
  font-weight: 600;
}

.status.active {
  color: #16a34a;
}

.status.inactive {
  color: #6b7280;
}

.empty {
  text-align: center;
  padding: 24px;
  color: #9ca3af;
}
</style>
